import {
  FetcherUtils,
  RenderingServices,
  utils,
} from '@wallaby-ui/core';
import React from 'react';
import {DocumentLinkProps} from 'src/js/containers/file/file_types';

export interface BaseDocumentLinkParamsType extends DocumentLinkProps {
  hrefTo: string;
  isAllowed: boolean;
  children?: React.ReactNode;
}

export function baseDocumentLinkParams(
  params: DocumentLinkProps,
  services: RenderingServices = {},
  documentLinkDisplayName = ''
): BaseDocumentLinkParamsType {
  const {store} = services;
  const {
    documentDetailRoute,
    docId = null,
    searchParams = {},
  } = params;
  const encodedSearchParams =
    FetcherUtils.transformJSONToUrlEncodedParams(searchParams);
  const newPathName = `${documentDetailRoute}${
    docId ? `/${encodeURIComponent(docId)}` : ''
  }`;
  const hrefTo = `${newPathName}?${encodedSearchParams}`;
  const isAllowed = true; // TODO: PDH-? disallow links if we don't have permissions?

  return {...params, hrefTo, isAllowed};
}
